import { MapCell } from "./MapCell";
import { MapRowSettings } from "./MapRowSettings";
import { ObstacleMapData } from "../Obstacles/ObstacleMapData";



/**
 * Radka preddefinovane mapy herniho sveta
 */
export class MapRow {
    /**
     * Sirka radky v poctu dlazdic
     */
    static readonly WIDTH = 7;

    /**
     * (RO) Data pro bunku radky
     */
    private _cells: number[];

    /**
     * (RO) Data pro jednotlive prekazky
     */
    get obstacles(): ObstacleMapData[] { return this._obstacles; }
    private _obstacles: ObstacleMapData[];

    /**
     * (RO) Nastaveni radky nebo undefined
     */
    get settings(): MapRowSettings { return this._settings; }
    private _settings: MapRowSettings;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(cells: number[], obstacles?: ObstacleMapData[], settings?: MapRowSettings) {
        this._cells = cells;
        this._obstacles = obstacles;
        this._settings = settings;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci data bunky
     * @param cellId Index bunky v radce
     * @param cellData Objekt s daty bunky, do ktereho se data ulozi
     */
    //-------------------------------------------------------------------------
    getCell(cellId: number, cellData: MapCell): MapCell {
        let cell = this._cells[cellId];

        if (cell == 0)
            return undefined;

        // Typ dlazdice
        cellData.init(cell);

        return cellData;
    }
}